import SessionActionType from './session.types';
import type { SessionAction, Lang } from './session.action';
import type { RoleId } from '../../data/tisms-api';

export interface SessionState {
  roleId: string | null;
  lang: Lang;
}

const INITIAL_STATE: SessionState = {
  roleId: null,
  lang: 'ta', // bilingual is the design default (Tamil sublabels rendered)
};

export default (state: SessionState = INITIAL_STATE, action: SessionAction): SessionState => {
  switch (action.type) {
    case SessionActionType.SESSION_SET_ROLE:
      return { ...state, roleId: action.payload };
    case SessionActionType.SESSION_SET_LANG:
      return { ...state, lang: action.payload as Lang };
    case SessionActionType.SESSION_RESET:
      return { ...INITIAL_STATE, lang: state.lang };
    default:
      return state;
  }
};
